export default {
  details: [],
};
